import { axiosInstance } from '@libs/axios/axios';
import { apiCall } from '@shared/entity';
import { Subscription, SubscriptionCreateData } from './entity';

export type CancellationFeedback = {
  reason: string;
  detail?: string;
  desiredPrice?: number;
  callRequested?: boolean;
  phone?: string;
};

export const subscriptionApi = {
  get: () => 'api/subscription',
  create: () => '/api/subscription/',
  change: () => '/api/subscription/change',
  extend: (subscriptionId: string) =>
    `/api/subscription/extend/${encodeURIComponent(subscriptionId)}`,
  cancel: (subscriptionId: string) => `/api/subscription/${encodeURIComponent(subscriptionId)}`,
};

export const postCreateSubscription = async (
  params: SubscriptionCreateData,
): Promise<{
  code: number;
  message: string;
  transId: string;
  redirect: string;
}> =>
  apiCall(
    async () => await axiosInstance.post(subscriptionApi.create(), params),
    'api.subscription.paymentCreateError',
  );

export const postCancelSubscription = async (
  subscriptionId: string,
  feedback: CancellationFeedback,
): Promise<boolean> =>
  apiCall(
    async () => await axiosInstance.post(subscriptionApi.cancel(subscriptionId), feedback),
    'api.subscription.cancelError',
  );

export const getSubscription = async (): Promise<Subscription> =>
  apiCall(async () => await axiosInstance.get(subscriptionApi.get()), 'api.subscription.notFound');

export const postExtendSubscription = async (subscriptionId: string): Promise<Subscription> =>
  apiCall(
    async () => await axiosInstance.post(subscriptionApi.extend(subscriptionId)),
    'api.subscription.extendError',
  );

export const postChangeSubscription = async (
  params: SubscriptionCreateData,
): Promise<
  | {
      code: number;
      message: string;
      transId: string;
      redirect: string;
    }
  | { paymentRequired: false }
> =>
  apiCall(
    async () => await axiosInstance.post(subscriptionApi.change(), params),
    'api.subscription.changePaymentError',
  );
